export class AppState {
	get dscid() { return parseInt(window["DSCID"]); }
	get dscaid() { return parseInt(window["DSCAID"]); }
}



// WEBPACK FOOTER //
// ./src/lib/stores/AppState.ts